/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { useMutation } from 'react-query';
import { useNavigate } from 'react-router-dom';

import { ApiPaths } from '@fai/constants/shared-urls';
import Paths from '@fai/friendli-suite/features/routes/paths';
import { baseKy } from '@fai/friendli-suite/shared/ky/base-ky';

import { resetAllIntegrations } from './reset-all-integrations';

export const useSignOut = () => {
  const navigate = useNavigate();

  const { mutate: postSignOut } = useMutation({
    mutationKey: 'signOut',
    mutationFn: () => baseKy.post(ApiPaths.SignOut),
    onSuccess: () => navigate(Paths.login.default),
  });

  const handleSignOut = async () => {
    postSignOut();
    await resetAllIntegrations();
  };

  return handleSignOut;
};
